import { ListItemButton } from "@mui/material";
import { styled } from "@mui/system";

interface SidebarListItemButtonProps {
    component?: React.ForwardRefExoticComponent<Pick<any, string | number | symbol> & React.RefAttributes<any>>;
    end?: boolean;
    to?: string;
}

export const SidebarListItemButton = styled(ListItemButton, {
    name: 'MuiSidebarListItemButton',
})<SidebarListItemButtonProps>(({theme}) => ({
    height: '40px',
    padding: '0 10px',
    borderRadius: '10px',
    color: theme.palette.text.secondary,
    transition: 'background-color 150ms ease, color 150ms ease',

    '& .MuiListItemText-root': {
        margin: 0,
    },
    '& .MuiListItemText-primary': {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.2,
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    '& .MuiListItemIcon-root': {
        width: '32px',
        minWidth: '32px',
        color: 'inherit',
        '& svg': { fontSize: '1.25rem' },
    },

    '&:hover': {
        backgroundColor: '#F1F3F6',
        color: theme.palette.text.primary,
    },

    '&.Mui-selected': {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,

        '&:hover': { backgroundColor: theme.palette.secondary.light },
        '& .MuiListItemText-primary': {
            color: theme.palette.secondary.main,
            fontWeight: 600,
        },
    },
}));
